import { StatusInfo } from "../common/Status";
import { OrderStatus } from "./types";

export function getOrderStatusInfo(status: OrderStatus): StatusInfo {
	const map: Record<OrderStatus, StatusInfo> = {
		PENDING: { text: 'Pendiente', class: 'secondary', actionText: '' },
		CONFIRMED: { text: 'Confirmada', class: 'info', actionText: 'Confirmar orden' },
		PROCESSING: { text: 'En proceso', class: 'warning', actionText: 'Procesar orden' },
		PROCESSED: { text: 'Procesada', class: 'primary', actionText: 'Orden procesada' },
		ON_HOLD: { text: 'En espera', class: 'secondary', actionText: 'Orden en espera' },
		COMPLETED: { text: 'Completada', class: 'success', actionText: 'Completar orden' }, 
		CANCELLED: { text: 'Cancelada', class: 'danger', actionText: 'Cancelar orden' },
		FAILED: { text: 'Fallida', class: 'danger', actionText: '' },
	};

	return map[status] ?? { text: String(status), class: 'secondary' };
}